import React from 'react';

import {
	FlexContainer,
	Avatar,
	Title,
	AttributeName,
	AttributeValue,
	LinkedIssueCard,
} from './styled.tsx';

export const TitleSkeleton = () => (
	<FlexContainer marginBottom={16}>
		<Avatar />
		<Title />
	</FlexContainer>
);

const AttributesListItem = () => (
	<FlexContainer>
		<AttributeName />
		<AttributeValue />
	</FlexContainer>
);

export const AttributesListSkeleton = () => (
	<>
		<AttributesListItem />
		<AttributesListItem />
		<AttributesListItem />
		<AttributesListItem />
	</>
);

export const LinkedIssuesSkeleton = () => (
	<div>
		<LinkedIssueCard />
		<LinkedIssueCard />
	</div>
);
